import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { API_URL } from "../../Constants";
import { AuthContext } from "../context/AuthContext";

const Greeting = () => {
  const { user } = useContext(AuthContext);
  const token = localStorage.getItem("token");
  const companyId =
    user?.accountType === "COMPANY" ? user?.id : user?.companyId;

  const [greetings, setGreetings] = useState([]);
  const [formData, setFormData] = useState({
    userType: "",
    greetingType: [],
    name: "",
    phone: "",
    companyName: "",
    birthdayDate: "",
  });
  const [editId, setEditId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const fetchGreetings = async () => {
    try {
      const res = await axios.get(
        `${API_URL}/api/greetings/company/${companyId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setGreetings(res.data);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  useEffect(() => {
    fetchGreetings();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "greetingType") {
      setFormData({
        ...formData,
        [name]: value.split(",").map((s) => s.trim()),
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async () => {
    const payload = { ...formData, companyId };
    try {
      if (editId) {
        await axios.put(`${API_URL}/api/greetings/${editId}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else {
        await axios.post(`${API_URL}/api/greetings`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }
      setShowModal(false);
      setEditId(null);
      setFormData({
        userType: "",
        greetingType: [],
        name: "",
        phone: "",
        companyName: "",
        birthdayDate: "",
      });
      fetchGreetings();
    } catch (err) {
      console.error("Submit error:", err);
    }
  };

  const handleEdit = (g) => {
    setEditId(g.greetingId);
    setFormData({
      userType: g.userType || "",
      greetingType: g.greetingType || [],
      name: g.name || "",
      phone: g.phone || "",
      companyName: g.companyName || "",
      birthdayDate: g.birthdayDate || "",
    });
    setShowModal(true);
  };

  const confirmDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_URL}/api/greetings/${deleteId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDeleteId(null);
      setShowDeleteModal(false);
      fetchGreetings();
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <div className="p-2 bg-gray-100 dark:bg-gray-900 dark:text-white">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Greetings Management</h2>
        <button
          className="px-1 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700 flex items-center gap-2"
          onClick={() => {
            setShowModal(true);
            setEditId(null);
            setFormData({
              userType: "",
              greetingType: [],
              name: "",
              phone: "",
              companyName: "",
              birthdayDate: "",
            });
          }}
        >
          <FaPlus /> Add Greeting
        </button>
      </div>

      <div className="overflow-x-auto">
        {/* <table className="min-w-full border rounded shadow text-sm">
          <thead>
            <tr className="bg-gray-200 dark:bg-gray-800">
              <th className="px-2 py-2">S No.</th>
              <th className="px-2 py-2">User Type</th>
              <th className="px-2 py-2">Greeting Type</th>
              <th className="px-2 py-2">Name</th>
              <th className="px-2 py-2">Phone</th>
              <th className="px-2 py-2">Company</th>
              <th className="px-2 py-2">Birthday</th>
              <th className="px-2 py-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {greetings.length > 0 ? (
              greetings.map((g, i) => (
                <tr
                  key={g.greetingId}
                  className="border-t hover:bg-gray-100 text-center dark:hover:bg-gray-700"
                >
                  <td className="px-2 py-2">{i + 1}</td>
                  <td className="px-2 py-2">{g.userType}</td>
                  <td className="px-2 py-2">{g.greetingType?.join(", ")}</td>
                  <td className="px-2 py-2">{g.name}</td>
                  <td className="px-2 py-2">{g.phone}</td>
                  <td className="px-2 py-2">{g.companyName}</td>
                  <td className="px-2 py-2">{g.birthdayDate}</td>
                  <td className="px-2 py-2 flex text-center gap-2">
                    <button
                      onClick={() => handleEdit(g)}
                      className="text-indigo-600"
                    >
                      <FaEdit />
                    </button>
                    <button
                      onClick={() => confirmDelete(g.greetingId)}
                      className="text-red-600"
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center py-4 text-gray-500">
                  No greetings found.
                </td>
              </tr>
            )}
          </tbody>
        </table> */}
        <table className="min-w-full border border-gray-300 dark:border-gray-700 rounded shadow text-sm">
          <thead>
            <tr className="bg-gray-200 dark:bg-gray-800 text-center">
              <th className="px-3 py-2 font-semibold">S No.</th>
              <th className="px-3 py-2 font-semibold">User Type</th>
              <th className="px-3 py-2 font-semibold">Greeting Type</th>
              <th className="px-3 py-2 font-semibold">Name</th>
              <th className="px-3 py-2 font-semibold">Phone</th>
              <th className="px-3 py-2 font-semibold">Company</th>
              <th className="px-3 py-2 font-semibold">Birthday</th>
              <th className="px-3 py-2 font-semibold">Actions</th>
            </tr>
          </thead>

          <tbody>
            {greetings.length > 0 ? (
              greetings.map((g, i) => (
                <tr
                  key={g.greetingId}
                  className="border-t text-center hover:bg-gray-100 dark:hover:bg-gray-700"
                >
                  <td className="px-3 py-2">{i + 1}.</td>
                  <td className="px-3 py-2">{g.userType}</td>
                  <td className="px-3 py-2">{g.greetingType?.join(", ")}</td>
                  <td className="px-3 py-2 whitespace-nowrap">{g.name}</td>
                  <td className="px-3 py-2 whitespace-nowrap">{g.phone}</td>
                  <td className="px-3 py-2">{g.companyName || "-"}</td>
                  <td className="px-3 py-2">{formatDate(g.birthdayDate)}</td>
                  <td className="px-3 py-2">
                    <div className="flex justify-center gap-1">
                      <button
                        onClick={() => handleEdit(g)}
                        className="text-indigo-600 hover:text-indigo-800"
                      >
                        <FaEdit />
                      </button>

                      <button
                        onClick={() => confirmDelete(g.greetingId)}
                        className="text-red-600 hover:text-red-800"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center py-6 text-gray-500">
                  No greetings found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-xl w-full max-w-md max-h-[90vh] custom-scroll">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-800 dark:text-white">
                {editId ? "Edit" : "Add"} Greeting
              </h3>
              <button
                onClick={() => {
                  setShowModal(false);
                  setEditId(null);
                }}
                className="text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-gray-100"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <div className="space-y-4">
              {[
                { field: "userType", label: "User Type", type: "text" },
                { field: "name", label: "Name", type: "text" },
                { field: "phone", label: "Phone Number", type: "tel" },
                { field: "companyName", label: "Company Name", type: "text" },
                { field: "birthdayDate", label: "Birthday Date", type: "date" },
              ].map(({ field, label, type }) => (
                <div key={field} className="space-y-1">
                  <label
                    htmlFor={field}
                    className="block text-sm font-medium text-gray-700 dark:text-gray-300"
                  >
                    {label}
                  </label>
                  <input
                    id={field}
                    type={type}
                    name={field}
                    value={formData[field]}
                    onChange={handleInputChange}
                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-indigo-500 dark:focus:border-indigo-500"
                  />
                </div>
              ))}

              <div className="space-y-1">
                <label
                  htmlFor="greetingType"
                  className="block text-sm font-medium text-gray-700 dark:text-gray-300"
                >
                  Greeting Types (comma-separated)
                </label>
                <input
                  id="greetingType"
                  type="text"
                  name="greetingType"
                  value={formData.greetingType.join(", ")}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-indigo-500 dark:focus:border-indigo-500"
                />
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                  Separate multiple types with commas (e.g., Birthday,
                  Anniversary)
                </p>
              </div>
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => {
                  setShowModal(false);
                  setEditId(null);
                }}
                className="px-4 py-2 bg-gray-200 text-gray-800 hover:bg-gray-300 rounded-md transition-colors dark:bg-gray-600 dark:text-white dark:hover:bg-gray-500"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="px-4 py-2 bg-indigo-600 text-white hover:bg-indigo-700 rounded-md transition-colors dark:bg-indigo-700 dark:hover:bg-indigo-600"
              >
                {editId ? "Update Greeting" : "Create Greeting"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirm Modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-800 p-6 rounded shadow-lg max-w-sm">
            <p className="mb-4">
              Are you sure you want to delete this greeting?
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                className="px-4 py-2 bg-red-600 text-white hover:bg-red-700 rounded"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}



    </div>
  );
};

export default Greeting;
